import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import {
  useFetchAuthorisation,
  useFetchUserData
} from "../../utils/AppFunctions";
import { MdAdd, MdEdit } from "react-icons/md";
import config from "../../app-config";
import { tidy_date, tidy_time_difference } from "../../utils/helper";
import DataTable from "../../components/ui/DataTable";
import Button from "../../components/ui/Button";

export default function LibraryPage() {
  const navigate = useNavigate();
  const { isAuthorised, userRole } = useFetchAuthorisation("user");
  let user_data = useFetchUserData();

  const [query, setQuery] = useState("")
  const [loading, setLoading] = useState(true)
  const [libraryData, setLibraryData] = useState([])

  useEffect(() => {
    fetchLibrary()
  }, [])

  const fetchLibrary = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/library"
    let response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await response.json()
    if (data.status === 200) {
      setLibraryData(data.data)
    }
    setLoading(false)
  }

  const table_columns = [
    {
      header: "Title",
      accessor: "title"
    },
    {
      header: "Subtitle",
      accessor: "subtitle",
    },
    {
      header: "Status",
      accessor: "is_published",
      modifier: (data) => (data ? "Published" : "Draft"),
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]
  return (
    <AdminLayout navSelected={"Library Items"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Library</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/library/details?library_id=new")
            }}
          >
            <MdAdd size={16} />
            New Item
          </button>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {libraryData.map((library, index) => {
            if (!JSON.stringify(library).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">

                  <h3>{library.title}</h3>
                  <h3 className='card-subtitle'>{library.subtitle}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/library/details?library_id=" + library.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}
          <DataTable
            columns={table_columns}
            data={libraryData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" icon={MdEdit} onClick={() => navigate(`/admin/library/details?library_id=${row.id}`)}>
                    Edit
                  </Button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}